import { Spacing } from '@doordash/design-language';

var SeparatorType;

(function (SeparatorType) {
  SeparatorType["Separator"] = "Separator";
  SeparatorType["InsetBorder"] = "InsetBorder";
  SeparatorType["FullBorder"] = "FullBorder";
  SeparatorType["Tall"] = "Tall";
})(SeparatorType || (SeparatorType = {}));

var SeparatorSize;

(function (SeparatorSize) {
  SeparatorSize[SeparatorSize["Small"] = Spacing.XxSmall] = "Small";
  SeparatorSize[SeparatorSize["Medium"] = Spacing.Small] = "Medium";
  SeparatorSize[SeparatorSize["Large"] = Spacing.Large] = "Large";
})(SeparatorSize || (SeparatorSize = {}));

export { SeparatorSize, SeparatorType };
